import Cookies from 'js-cookie';
import ApexCharts from 'apexcharts'
import autoTable from 'jspdf-autotable'

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

/* Import TinyMCE */
import tinymce from 'tinymce';

/* Default icons are required. After that, import custom icons if applicable */
import 'tinymce/icons/default/icons.js';

/* Required TinyMCE components */
import 'tinymce/themes/silver/theme.js';
import 'tinymce/models/dom/model.js';

/* Import a skin (can be a custom skin instead of the default) */
import 'tinymce/skins/ui/oxide/skin.css';

/* Import plugins */
import 'tinymce/plugins/advlist/plugin.js';
import 'tinymce/plugins/code/plugin.js';
import 'tinymce/plugins/emoticons/plugin.js';
import 'tinymce/plugins/emoticons/js/emojis.js';
import 'tinymce/plugins/link/plugin.js';
import 'tinymce/plugins/lists/plugin.js';
import 'tinymce/plugins/table/plugin.js';
import 'tinymce/plugins/image/plugin.js';
import 'tinymce/plugins/media/plugin.js';
import 'tinymce-i18n/langs6/pt_BR.js';

window.jspdf = require("jspdf");
window.XLSX = require("xlsx");
window.Cookies = Cookies;

window.globalTable = [];
window.globalGuards = [];

const DaysOfWeek = [
	lang.get('backoffice.global.sun'),
	lang.get('backoffice.global.mon'),
	lang.get('backoffice.global.tue'),
	lang.get('backoffice.global.wed'),
	lang.get('backoffice.global.thu'),
	lang.get('backoffice.global.fri'),
	lang.get('backoffice.global.sat'),
]

const MonthsOfYear = [
	lang.get('backoffice.global.january'),
	lang.get('backoffice.global.february'),
	lang.get('backoffice.global.march'),
	lang.get('backoffice.global.april'),
	lang.get('backoffice.global.may'),
	lang.get('backoffice.global.june'),
	lang.get('backoffice.global.july'),
	lang.get('backoffice.global.august'),
	lang.get('backoffice.global.september'),
	lang.get('backoffice.global.october'),
	lang.get('backoffice.global.november'),
	lang.get('backoffice.global.december'),
]

window.ApexCharts = function(el, options = {}) {
	return new ApexCharts(el, options)
}

var formatCurrency = function(value) {
	return new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(value)
}
window.formatCurrency = formatCurrency

var highlightValueFromFilters = function(filters, key, value) {
	let filter = filters.filter(item => (item.field === key || item.field === 'general-search') && item.type === 'like')[0]
	if (!filter) return value;

	const regex = new RegExp(`(${filter.value})`, 'gi');
	return value.replace(regex, '<span class="bg-warning">$1</span>');
}

var initTooltips = function () {
    document
        .querySelectorAll('[data-bs-toggle="tooltip"]')
        .forEach(function (el) {
            if (!bootstrap.Tooltip.getInstance(el)) {
                new bootstrap.Tooltip(el);
            }
        });
}

window.highlightValueFromFilters = highlightValueFromFilters

window.initTooltips = initTooltips

// Backoffice shared helpers
window.Backoffice = window.Backoffice || {}

;(function(Backoffice, $, window, document) {
	function getSafeLang(key, fallback) {
		try {
			if (window.lang && typeof window.lang.get === 'function') {
				const val = window.lang.get(key)
				if (val !== undefined && val !== null && String(val).trim() !== '') return val
			}
		} catch (e) {}
		return fallback
	}

	/**
	 * Show the global #confirmation-modal and resolve to true/false.
	 *
	 * Options:
	 * - title: string
	 * - body: string (text)
	 * - bodyHtml: string (html). If provided, takes precedence over body.
	 * - confirmButtonText: string (optional)
	 * - cancelButtonText: string (optional)
	 */
	Backoffice.confirm = function(options = {}) {
		return new Promise(function(resolve) {
			const modalEl = document.getElementById('confirmation-modal')
			/* if (!modalEl || typeof window.bootstrap === 'undefined' || !window.bootstrap.Modal) {
				const promptText = options.body || options.bodyHtml || ''
				resolve(window.confirm(promptText))
				return
			} */

			const $modal = $('#confirmation-modal')
			const title = options.title ?? getSafeLang('backoffice.global.attention', 'Attention')
			$modal.find('.modal-title').text(title)

			if (options.bodyHtml !== undefined) {
				$modal.find('.modal-body').html(options.bodyHtml)
			} else {
				$modal.find('.modal-body').text(options.body ?? '')
			}

			if (options.confirmButtonText) {
				$modal.find('#modal-confirm').text(options.confirmButtonText)
			}
			if (options.cancelButtonText) {
				// Try common selectors for cancel buttons; if not found, skip silently
				$modal.find('[data-bs-dismiss="modal"], .btn-secondary, .btn-outline-secondary').first().text(options.cancelButtonText)
			}

			let resolved = false
			const finalize = (val) => {
				if (resolved) return
				resolved = true
				resolve(val)
			}

			const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl)

			// If the modal closes without confirming, resolve(false)
			$modal
				.off('hidden.bs.modal.boManualConfirm')
				.one('hidden.bs.modal.boManualConfirm', function() {
					finalize(false)
				})

			$modal.find('#modal-confirm')
				.off('click.boManualConfirm')
				.one('click.boManualConfirm', function() {
					finalize(true)
					modal.hide()
				})

			modal.show()
		})
	}

	function normalizeFormDataValue(value) {
		if (value instanceof File) {
			return `__FILE__:${value.name}:${value.size}:${value.type}:${value.lastModified}`
		}
		return String(value)
	}

	function snapshotForm(formEl) {
		const fd = new FormData(formEl)
		const map = {}
		for (const [key, value] of fd.entries()) {
			if (!Object.prototype.hasOwnProperty.call(map, key)) map[key] = []
			map[key].push(normalizeFormDataValue(value))
		}
		const keys = Object.keys(map).sort()
		const normalized = {}
		for (const key of keys) {
			normalized[key] = map[key].slice().sort()
		}
		return JSON.stringify(normalized)
	}

	Backoffice.unsavedChanges = Backoffice.unsavedChanges || {}

	/**
	 * Attach an unsaved-changes guard to a form.
	 *
	 * Options:
	 * - form: selector | HTMLFormElement (required)
	 * - cancel: selector | HTMLElement (optional) - element that triggers navigation away
	 * - cancelUrl: string (optional) - fallback URL if history.back isn't possible
	 * - beforeUnload: boolean (default true)
	 * - baselineDelayMs: number (default 500)
	 * - debounceMs: number (default 50)
	 * - confirmationTitle: string (optional)
	 * - confirmationText: string (optional)
	 * - onNavigate: function() (optional) - custom navigation handler
	 *
	 * Returns a controller with:
	 * - isDirty(): boolean
	 * - refresh(): boolean
	 * - resetBaseline(): void
	 * - confirmLeave(): Promise<boolean>
	 * - destroy(): void
	 */
	Backoffice.unsavedChanges.attach = function(options = {}) {
		const form = typeof options.form === 'string' ? document.querySelector(options.form) : options.form
		if (!form) {
			return {
				isDirty: () => false,
				refresh: () => false,
				resetBaseline: () => {},
				confirmLeave: () => Promise.resolve(true),
				destroy: () => {},
			}
		}

		const cancelEl = typeof options.cancel === 'string' ? document.querySelector(options.cancel) : options.cancel
		const baselineDelayMs = Number.isFinite(options.baselineDelayMs) ? options.baselineDelayMs : 500
		const debounceMs = Number.isFinite(options.debounceMs) ? options.debounceMs : 50
		const beforeUnload = options.beforeUnload !== false

		let initialSnapshot = ''
		let isSubmitting = false
		let bypassBeforeUnloadOnce = false
		let dirty = false
		let pending = null
		let destroyed = false

		const confirmationTitle = options.confirmationTitle ?? getSafeLang('backoffice.global.attention', 'Attention')
		const confirmationText = options.confirmationText ?? getSafeLang(
			'backoffice.global.unsaved_changes_confirm',
			'You have unsaved changes. Do you want to leave without saving?'
		)

		function refresh() {
			if (destroyed) return false
			try {
				dirty = snapshotForm(form) !== initialSnapshot
			} catch (e) {
				dirty = true
			}
			return dirty
		}

		function schedule() {
			if (destroyed) return
			if (pending) window.clearTimeout(pending)
			pending = window.setTimeout(function() {
				refresh()
			}, debounceMs)
		}

		function defaultNavigate() {
			if (typeof options.onNavigate === 'function') {
				options.onNavigate()
				return
			}

			if (!options.cancelUrl && (window.history && window.history.length > 1)) {
				window.history.back()
				return
			}

			const fromCancel = cancelEl ? cancelEl.getAttribute('data-cancel-url') : null
			const fallback = options.cancelUrl || fromCancel
			window.location.href = fallback || '/'
		}

		function confirmLeave() {
			return Backoffice.confirm({
				title: confirmationTitle,
				body: confirmationText,
			})
		}

		function onCancelClick(e) {
			e.preventDefault()
			if (isSubmitting) return
			refresh()
			if (!dirty) {
				defaultNavigate()
				return
			}
			confirmLeave().then(function(ok) {
				if (!ok) return
				// User explicitly confirmed leaving; don't show the native beforeunload prompt
				bypassBeforeUnloadOnce = true
				dirty = false
				defaultNavigate()
			})
		}

		function onBeforeUnload(e) {
			if (!beforeUnload) return
			if (isSubmitting) return
			if (bypassBeforeUnloadOnce) return
			refresh()
			if (!dirty) return
			e.preventDefault()
			e.returnValue = ''
		}

		// Baseline snapshot after page initialization settles (select2/daterangepicker triggers etc)
		window.setTimeout(function() {
			if (destroyed) return
			initialSnapshot = snapshotForm(form)
			dirty = false
		}, baselineDelayMs)

		form.addEventListener('input', schedule, true)
		form.addEventListener('change', schedule, true)
		form.addEventListener(
			'submit',
			function() {
				isSubmitting = true
			},
			true
		)

		if (cancelEl) {
			cancelEl.addEventListener('click', onCancelClick)
		}
		window.addEventListener('beforeunload', onBeforeUnload)

		return {
			isDirty: () => dirty,
			refresh,
			resetBaseline: () => {
				if (destroyed) return
				initialSnapshot = snapshotForm(form)
				dirty = false
			},
			confirmLeave,
			destroy: () => {
				destroyed = true
				if (pending) window.clearTimeout(pending)
				form.removeEventListener('input', schedule, true)
				form.removeEventListener('change', schedule, true)
				if (cancelEl) cancelEl.removeEventListener('click', onCancelClick)
				window.removeEventListener('beforeunload', onBeforeUnload)
			},
		}
	}
})(window.Backoffice, window.jQuery, window, document)

tinymce.init({
    selector: 'textarea.editor',
    plugins: 'advlist code emoticons link lists table image media contextmenu',
	contextmenu: 'copy paste | link image inserttable | cell row column deletetable', // Itens personalizados no menu de contexto
    toolbar: 'bold italic | bullist numlist | link emoticons | image media',
    skin: false,
    content_css: false,
    promotion:false,
    image_uploadtab:true,
    images_upload_url:"/admin/admin/ckeditor/upload",
	entity_encoding: "raw",
    entities: "",
    convert_entities: false,
    images_upload_handler: (blobInfo, progress) => new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.withCredentials = true;
        xhr.open('POST', '/admin/admin/ckeditor/upload');
        var token = document.querySelector('[name="_token"]').value;
        xhr.setRequestHeader("X-CSRF-Token", token);
      
        xhr.upload.onprogress = (e) => {
          progress(e.loaded / e.total * 100);
        };
      
        xhr.onload = () => {
          if (xhr.status === 403) {
            reject({ message: 'HTTP Error: ' + xhr.status, remove: true });
            return;
          }
      
          if (xhr.status < 200 || xhr.status >= 300) {
            reject('HTTP Error: ' + xhr.status);
            return;
          }
      
          const json = JSON.parse(xhr.responseText);
      
          if (!json || typeof json.location != 'string') {
            reject('Invalid JSON: ' + xhr.responseText);
            return;
          }
      
          resolve(json.location);
        };
      
        xhr.onerror = () => {
          reject('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
        };
      
        const formData = new FormData();
        formData.append('file', blobInfo.blob(), blobInfo.filename());
      
        xhr.send(formData);
      }),
    images_upload_credentials:true,
    language:'pt_BR',
  });

window.searcherTable 						= []
window.selectedData 						= []
window.selectedDataTable 					= []
window.sharedTableData 						= []
window.newSearcherSelectedIds 				= []
window.newSelectionSearcherSelectedIds 		= []
window.excludedData 						= []

window.modals 								= []

window.sharedTables						= []

window.AnimateCSS = (element, animation, prefix = 'animate__') =>
    // We create a Promise and return it
    new Promise((resolve, reject) => {
        const animationName = `${prefix}${animation}`
        const node = element
        
        node.addClass(`${ prefix }animated`)
        node.addClass(`${ animationName }`)
        
        // When the animation ends, we clean the classes and resolve the Promise
        function handleAnimationEnd(event) {
            event.stopPropagation()
            node.removeClass(`${ prefix }animated`)
            node.removeClass(`${ animationName }`)
            resolve('Animation ended')
        }
        
        node.on('animationend', handleAnimationEnd)
    }
)

window.isElementInView = (element, fullyInView) => {
	var pageTop = $(window).scrollTop();
	var pageBottom = pageTop + $(window).height();
	var elementTop = $(element).offset().top;
	var elementBottom = elementTop + $(element).height();

	if (fullyInView === true) {
		return ((pageTop < elementTop) && (pageBottom > elementBottom));
	} else {
		return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
	}
}

window.attachToTop = (scrollable, element, limiter, nextElement, fullyInView = false, accountForScrollWidth = true, delta = 10) => {
	scrollable.scroll(function() {
		if (window.isElementInView(limiter, fullyInView)) {
			element.removeClass('attached').removeClass('attach-top')
			element.width('100%')
			nextElement.css('margin-top', 'unset')
		} else {
			element.addClass('attached').addClass('attach-top')
			element.width(scrollable.width() - (accountForScrollWidth ? 8 : 0))
			nextElement.css('margin-top', element.height() + limiter.height() + delta)
		}
	})
}

window.cloneAttachToTop = (scrollable, element, limiter, fullyInView = false, accountForScrollWidth = true) => {
	scrollable.scroll(function() {
		if (window.isElementInView(limiter, fullyInView)) {
			$('.attached-clone').remove()
		} else {
			if (scrollable.find('.attached-clone').length > 0) return;

			let clone = element.clone()
			clone.addClass('attached-clone').addClass('attached').addClass('attach-top')
			clone.width(scrollable.width() - (accountForScrollWidth ? 8 : 0))
			scrollable.prepend(clone)
		}
	})
}

window.makeDateRangePicker = (jqelem, format, timerPicker = false) => {
	if (!format) { format = "YYYY-MM-DD" }

	jqelem.daterangepicker({
		autoUpdateInput: false,
		timePicker: timerPicker,
		drops: 'up',
		timePicker24Hour: true,
		locale: {
			format: format,
			separator: " - ",
			applyLabel: lang.get('backoffice.global.apply'),
			cancelLabel: lang.get('backoffice.global.cancel'),
			fromLabel: lang.get('backoffice.global.of'),
			toLabel: lang.get('backoffice.global.to'),
			customRangeLabel: "Custom",
			daysOfWeek: DaysOfWeek,
			monthNames: MonthsOfYear,
			firstDay: 0
		}
	});
}

window.makeDatePicker = (jqelem, format, timePicker = false, extraOptions = {}) => {
    if (!format) { format = "YYYY-MM-DD"; }

    jqelem.daterangepicker($.extend({
        autoUpdateInput: false,
        singleDatePicker: true,
        timePicker: timePicker,
        showDropdowns: true,
        timePicker24Hour: true,
        locale: {
            format: format,
            separator: " - ",
            applyLabel: lang.get('backoffice.global.apply'),
            cancelLabel: lang.get('backoffice.global.cancel'),
            fromLabel: lang.get('backoffice.global.of'),
            toLabel: lang.get('backoffice.global.to'),
            customRangeLabel: "Custom",
            daysOfWeek: DaysOfWeek,
            monthNames: MonthsOfYear,
            firstDay: 0,
        }
    }, extraOptions));
}

Number.prototype.format = function(n, x) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
}

Tabulator.extendModule("localize", "langs", {
	"pt":{
		"data":{
			"loading": "A carregar", //data loader text
			"error": "Erro", //data error text
		},
		"ajax":{
			"loading": "A carregar'", //data loader text
			"error": "Erro", //data error text
		},
		"pagination":{
			"page_size": "Registos por página", //label for the page size select element
			"page_title": "Página",//tooltip text for the numeric page button, appears in front of the page number (eg. "Show Page" will result in a tool tip of "Show Page 1" on the page 1 button)
			"first": "Primeira", //text for the first page button
			"first_title": "Primeira página", //tooltip text for the first page button
			"last": "Última",
			"last_title": "Última página",
			"prev": "Anterior",
			"prev_title": "Página anterior",
			"next": "Próxima",
			"next_title": "Próxima página",
			"all": "Todas",
			"counter": {
				"showing": "A mostrar",
				"of": "de",
				"rows": "registos",
				"pages": "páginas",
			}
		}
	}
})

Tabulator.extendModule("edit", "editors", {
    priceEditor: function(cell, onRendered, success, cancel, editorParams){
		//cell - the cell component for the editable cell
		//onRendered - function to call when the editor has been rendered
		//success - function to call to pass thesuccessfully updated value to Tabulator
		//cancel - function to call to abort the edit and return to a normal cell
		//editorParams - params object passed into the editorParams column definition property

		//create and style editor
		var cellValue = cell.getValue() 

		if (cellValue === false) {
			return
		} else {
			cellValue = Number(cellValue).format(2)
		}

		var editor = document.createElement("input");
		editor.setAttribute("type", "number");

		//create and style input
		editor.style.padding = "4px";
		editor.style.width = "100%";
		editor.style.boxSizing = "border-box";
		editor.className = 'input-no-step'

		editor.value = cellValue

		//set focus on the select box when the editor is selected (timeout allows for editor to be added to DOM)
		onRendered(function(){
			editor.focus();
			editor.style.css = "100%";
		});

		function onChange(e) {
            if (editor.value != cellValue) {
                success(Number(editor.value));
            } else {
                cancel();
            }
        }

		editor.addEventListener("change", onChange);
		editor.addEventListener("blur", onChange);

		//submit new value on enter
        editor.addEventListener("keydown", function (e) {
            if (e.keyCode == 13) {
                success(editor.value);
            }

            if (e.keyCode == 27) {
                cancel();
            }
        });

		//return the editor element
		return editor;
    },
	customNumberEditor: function(cell, onRendered, success, cancel, editorParams){
		//cell - the cell component for the editable cell
		//onRendered - function to call when the editor has been rendered
		//success - function to call to pass thesuccessfully updated value to Tabulator
		//cancel - function to call to abort the edit and return to a normal cell
		//editorParams - params object passed into the editorParams column definition property

		//create and style editor
		var cellValue = cell.getValue() 

		if (cellValue === false) {
			return
		} else {
			cellValue = Number(cellValue)
		}

		var editor = document.createElement("input");
		editor.setAttribute("type", "number");

		//create and style input
		editor.style.padding = "4px";
		editor.style.width = "100%";
		editor.style.boxSizing = "border-box";

		editor.value = cellValue

		if (editorParams && editorParams.elementAttributes) {
			if (editorParams.elementAttributes.class) { editor.className = editorParams.elementAttributes.class }
		}

		//set focus on the select box when the editor is selected (timeout allows for editor to be added to DOM)
		onRendered(function(){
			editor.focus();
			editor.style.css = "100%";
		});

		function onChange(e) {
            if (editor.value != cellValue) {
                success(Number(editor.value));
            } else {
                cancel();
            }
        }

		editor.addEventListener("change", onChange);
		editor.addEventListener("blur", onChange);

		//submit new value on enter
        editor.addEventListener("keydown", function (e) {
            if (e.keyCode == 13) {
                success(editor.value);
            }

            if (e.keyCode == 27) {
                cancel();
            }
        });

		//return the editor element
		return editor;
    },
	dateMinMaxFilterEditor: function(cell, onRendered, success, cancel, editorParams){
		var end;

		var container = document.createElement("span");

		//create and style inputs
		var start = document.createElement("input");
		start.setAttribute("type", "date");
		start.setAttribute("placeholder", "Min");
		start.style.padding = "4px";
		start.style.width = "50%";
		start.style.boxSizing = "border-box";
		start.setAttribute('value', editorParams.start);

		function buildValues() {
			success({
				start: start.value,
				end: end.value,
			});
		}

		function keypress(e) {
			if (e.keyCode == 13) {
				buildValues();
			}

			if (e.keyCode == 27) {
				cancel();
			}
		}

		end = start.cloneNode();
		end.setAttribute("placeholder", "Max");
		end.setAttribute('value', editorParams.end);

		start.addEventListener("change", buildValues);
		start.addEventListener("blur", buildValues);
		start.addEventListener("keydown", keypress);

		end.addEventListener("change", buildValues);
		end.addEventListener("blur", buildValues);
		end.addEventListener("keydown", keypress);

		container.appendChild(start);
		container.appendChild(end);

		return container;
    },
	minMaxFilterEditor: function(cell, onRendered, success, cancel, editorParams){
		var end;

		var container = document.createElement("span");

		//create and style inputs
		var start = document.createElement("input");
		start.setAttribute("type", "number");
		start.setAttribute("placeholder", "Min");
		start.setAttribute("min", 0);
		start.setAttribute("max", 100);
		start.style.padding = "4px";
		start.style.width = "50%";
		start.style.boxSizing = "border-box";
		start.setAttribute('value', editorParams.start);

		function buildValues() {
			success({
				start: start.value,
				end: end.value,
			});
		}

		function keypress(e) {
			if (e.keyCode == 13) {
				buildValues();
			}

			if (e.keyCode == 27) {
				cancel();
			}
		}

		end = start.cloneNode();
		end.setAttribute("placeholder", "Max");
		end.setAttribute('value', editorParams.end);

		start.addEventListener("change", buildValues);
		start.addEventListener("blur", buildValues);
		start.addEventListener("keydown", keypress);

		end.addEventListener("change", buildValues);
		end.addEventListener("blur", buildValues);
		end.addEventListener("keydown", keypress);


		container.appendChild(start);
		container.appendChild(end);

		return container;
    }
});

Tabulator.extendModule("format", "formatters", {
    currencyEditable: function(cell, formatterParams){
        if (cell.getColumn().getDefinition().editor && cell.getValue() !== false){
			//cell is editable
			return `
				<button type="button" class="btn btn-sm btn-transparent p-0 text-primary w-100 d-flex justify-content-between align-items-center align-self-center">
					${ window.formatCurrency(cell.getValue()) }
					<i class="fas fa-edit"></i>
				</button>
			`
		} else {
			//cell is not editable
			return window.formatCurrency(cell.getValue())
		}
    },
	currency: function(cell, formatterParams){
		if (isNaN(cell.getValue())) {
			return '';
		} else {
        	return window.formatCurrency(cell.getValue())
		}
    },
	customNumberStepper: function(cell, formatterParams, onRendered) {
		//cell - the cell component
		//formatterParams - parameters set for the column
		//onRendered - function to call when the formatter has been rendered

		if (cell.getColumn().getDefinition().editor && cell.getValue() !== false) {
			//cell is editable
			return `
				<button type="button" class="btn btn-sm btn-transparent p-0 text-primary w-100 d-flex justify-content-between align-items-center align-self-center">
					${ cell.getValue() }
					<i class="fas fa-edit"></i>
				</button>
			`
		} else {
			//cell is not editable
			return cell.getValue() === false ? '' : cell.getValue()
		}
	},
	currencyHighlight: function(cell, formatterParams){
		cell.getElement().classList.add('text-end')
		//cell.getElement().classList.add(cell.getValue() < 0 ? 'bg-danger' : 'bg-success')
		cell.getElement().classList.add(cell.getValue() < 0 ? 'text-danger' : 'text-success')

		let val = window.formatCurrency(cell.getValue())

		return val.replace('-', '')
    },
	transactionHighlightDesc: function(cell, formatterParams){
		cell.getElement().classList.add('text-end')
		//cell.getElement().classList.add(cell.getValue() < 0 ? 'bg-danger' : 'bg-success')
		cell.getElement().classList.add(cell.getValue() < 0 ? 'text-danger' : 'text-success')

		let icon = cell.getValue() < 0 ? '<i class="fas fa-minus-circle"></i>' : '<i class="fas fa-plus-circle"></i>'
		let desc = cell.getValue() < 0 ? lang.get('backoffice.card.debit') : lang.get('backoffice.card.credit')

		let val = window.formatCurrency(cell.getValue())

		return `
			<div class="d-flex flex-column">
				<div class="fw-bold">${ icon } ${ desc }</div>
				<div>${ val.replace('-', '') }</div>
			</div>
		`
    },
	momentDatetime: function(cell, formatterParams){
		return moment(cell.getValue()).isValid() ? moment(cell.getValue()).format('DD-MM-YYYY HH:mm:ss') : '-'
    },
	momentDate: function(cell, formatterParams){
		return moment(cell.getValue()).isValid() ? moment(cell.getValue()).format('DD-MM-YYYY') : '-'
    },
	goToPage: function(cell, formatterParams) {
		let data = cell.getData()
		let url = formatterParams.url || ''
		url = url.replace('replace-me', data[formatterParams.field])

		return `<a class="fw-bold" href="${ url }">${ cell.getValue() }</a>`
	},
	rowSelectionCustom: function(cell, formatterParams, onRendered) {
		var checkbox = document.createElement("input");
		var blocked = false;

		checkbox.type = 'checkbox';

		checkbox.setAttribute("aria-label", "Select Row");
		
		if (this.table.modExists("selectRow", true)) {
			checkbox.addEventListener("click", (e) => {
				e.stopPropagation();
			});

			if (typeof cell.getRow == 'function') {
				var row = cell.getRow();

				if (this.table.options.selectableRowsCheck !== undefined && !this.table.options.selectableRowsCheck.call(this.table, row)) {
					//checkbox.setAttribute('disabled', '')
					checkbox = ''
				} else {
					checkbox.addEventListener("change", (e) => {
						if (this.table.options.selectableRowsRangeMode === "click") {
							if (!blocked) {
								row.toggleSelect();
							} else {
								blocked = false;
							}
						} else {
							row.toggleSelect();
						}
					});

					if (this.table.options.selectableRowsRangeMode === "click") {
						checkbox.addEventListener("click", (e) => {
							blocked = true;
							this.table.modules.selectRow.handleComplexRowClick(row._row, e);
						});
					}

					if (formatterParams !== undefined && formatterParams.is_checked) {
						checkbox.checked = true
					} else {
						checkbox.checked = row.isSelected && row.isSelected();
					}
					this.table.modules.selectRow.registerRowSelectCheckbox(row, checkbox);
				}
			} else {
				checkbox.classList.add('header-selection-toggler')

				checkbox.addEventListener("change", (e) => {
					if (this.table.modules.selectRow.selectedRows.length) {
						this.table.deselectRow();
					} else {
						this.table.selectRow(formatterParams.rowRange);
					}
					
					let changed_event = new CustomEvent('select-all-triggered', { detail: { cell: cell, selectall: this.table.modules.selectRow.selectedRows.length > 0 } })
					this.table.element.dispatchEvent(changed_event)
				});

				this.table.modules.selectRow.registerHeaderSelectCheckbox(checkbox);
			}
		}
		return checkbox;
	},
	percentage: function(cell, formatterParams, onRendered) {
		if (`${ cell.getValue() }`.length == 0) return cell.getValue()
		return `${ cell.getValue() }%`
	},
	highlightable: function(cell, formatterParams, onRendered) {
		return `${ highlightValueFromFilters(cell.getTable().getFilters(), formatterParams?.filter?.key || cell._cell.column.definition.field, cell.getValue()) }`
	},
	percentageHighlightWarning: function(cell, formatterParams) {
		if (cell.getValue() == '-' || cell.getValue() == 0 || cell.getValue() == '0') return '-'

		let val = cell.getValue()
		let icon = ''
		let cl = ''

		if (val < formatterParams.min) {
			icon = `<i title="${ formatterParams.message_fail !== undefined ? formatterParams.message_fail : '' }" class="fa-solid fa-circle-exclamation fa-fade"></i>`
			cl = 'text-danger'
		} else {
			icon = '<i class="fa-solid fa-check"></i>'
			cl = 'text-teal'
		}
		
		return `
			<span class="${ cl }">${ val }% &nbsp;${ icon }</span>
		`
	}
});

Tabulator.extendModule("filter", "filters", {
    "dateMinMaxFilterFunction": function(headerValue, rowValue, rowData, filterParams){
        //headerValue - the value of the header filter element
		//rowValue - the value of the column in this row
		//rowData - the data for the row being filtered
		//filterParams - params object passed to the headerFilterFuncParams property

		//convert strings into dates

		if (headerValue.start != "") {
			headerValue.start = new Date(headerValue.start);
		} 
		if (headerValue.end != "") {
			headerValue.end = new Date(headerValue.end );
		}
		
		//compare dates
		if (rowValue) {
			rowValue = new Date(rowValue);

			if (headerValue.start != "") {
				if (headerValue.end != "") {
					return moment(rowValue) >= headerValue.start && rowValue <= headerValue.end;
				} else {
					return rowValue >= headerValue.start;
				}
			} else {
				if (headerValue.end != "") {
					return rowValue <= headerValue.end;
				}
			}
		}

		return true; //must return a boolean, true if it passes the filter.
    },
	"minMaxFilterFunction": function(headerValue, rowValue, rowData, filterParams){
        //headerValue - the value of the header filter element
		//rowValue - the value of the column in this row
		//rowData - the data for the row being filtered
		//filterParams - params object passed to the headerFilterFuncParams property

		if (rowValue) {
			if (headerValue.start != "") {
				if (headerValue.end != "") {
					return rowValue >= headerValue.start && rowValue <= headerValue.end;
				} else {
					return rowValue >= headerValue.start;
				}
			} else {
				if (headerValue.end != "") {
					return rowValue <= headerValue.end;
				}
			}
		}

		return true; //must return a boolean, true if it passes the filter.
    }
});


Tabulator.extendModule("download", "downloaders", {
    remote: function(columns, options, interceptCB){
        let filters = this.getFilters()
		let fetch_options = {
			url: this.options.ajaxURL,
			method: this.options.ajaxConfig.method || 'GET',
			headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
			data: {
				filter: filters,
				export: true
			}
		}

		if (fetch_options.method == 'POST') {
			fetch_options.data = JSON.stringify(fetch_options.data)
		}

		$.ajax(fetch_options)
		.done(function(data) {
			var tempTable = new Tabulator(document.createElement('div'), {
				data: data, // pass the full dataset
				autoColumns :true
			});

			tempTable.on('dataProcessed', function(loadedData) {
				tempTable.download(options.format || 'csv', `table_${ new Date().toISOString().replace(/[-T:]/g, '').split('.')[0] }.${ options.format || 'csv' }`);
			})
		})
		.fail(function(jqXHR, textStatus, errorThrown) {
			console.error('Error fetching data:', errorThrown);
		})
    }
});

var SendBrowserNotification = window.SendBrowserNotification = function(title, options) {
	if (!("Notification" in window)) {
		// Check if the browser supports notifications
		console.log("This browser does not support desktop notification");
	} else if (Notification.permission === "granted") {
		// Check whether notification permissions have already been granted;
		return CreateNotification(title, options)
	} else if (Notification.permission !== "denied") {
		// We need to ask the user for permission
		Notification.requestPermission().then((permission) => {
			// If the user accepts, let's create a notification
			if (permission === "granted") {
				return CreateNotification(title, options)
			}
		});
	}
}

function CreateNotification(title, options = {}) {
	return new Notification(title, options)
}

function copyToClipboard(text) {
	// Modern API
	if (navigator.clipboard && window.isSecureContext) {
		return navigator.clipboard.writeText(text);
	}

	// Fallback
	return new Promise(function (resolve, reject) {
		const textArea = document.createElement('textarea');
		textArea.value = text;
		textArea.style.position = 'fixed';
		textArea.style.left = '-9999px';
		document.body.appendChild(textArea);
		textArea.select();

		try {
			document.execCommand('copy');
			resolve();
		} catch (err) {
			reject(err);
		} finally {
			document.body.removeChild(textArea);
		}
	});
}

$(function() {
	/*$('.nav-link').popover({
		container: 'body',
		trigger: 'hover',
		html: true 
	})*/

	$(document).on('click', '.dropdown-selection-item', function(e) {
		let type = $(this).data('type')
		$(this).closest('.dropdown').find('.dropdown-toggle').html($(this).html())

		$(this).closest('.card-body').find('.chart-controlled').each(function(index, item) {
			if ($(item).data('type') == type) {
				$(item).removeClass('d-none')
			} else {
				$(item).addClass('d-none')
			}
		})
	})

	if ($('.sidebar').hasClass('expanded')) {
		let active_nav = $('.nav-dropdown-items').find('.nav-link.active')
		if (active_nav) {
			active_nav.parent().parent().parent().addClass('open')
		}
	}

	$('[data-bs-toggle="popover"]').popover({
		container: 'body',
		trigger: 'hover',
		html: true 
	})

	$('.nav-main > .nav-link').on('click', function(e) {
		e.preventDefault()
	})

	$(document).on('click', 'header, .content-page, .app-footer',  function(e) {
		if ($('.sidebar').hasClass('compact')) {
			$('.nav-dropdown').removeClass('open')
		}
	})

	$('.nav-dropdown > .nav-link').on('click', function(e) {
		if ($(this).parent().hasClass('open')) {
			$(this).parent().removeClass('open')
		} else {
			if ($('.sidebar').hasClass('compact')) {
				$('.nav-dropdown').removeClass('open')
			}
			$(this).parent().addClass('open')
		}
	})

	/*$(document).on('select2:open', () => {
		document.querySelector('.select2-search__field').focus()
	});*/

	$(document).on('submit', 'form', function(e) {
		const form = this // native form element
		const $form = $(this)

		// Allow a single re-entrant submit when we intentionally call requestSubmit()
		if (form.dataset.boBypassSubmit === '1') {
			form.dataset.boBypassSubmit = '0'
			return
		}

		e.preventDefault()

		const submitNative = () => {
			// Some forms contain <input name="submit"> / <button name="submit">, which shadows form.submit
			if (typeof HTMLFormElement !== 'undefined' && typeof HTMLFormElement.prototype.submit === 'function') {
				HTMLFormElement.prototype.submit.call(form)
				return
			}
			if (typeof form.submit === 'function') {
				form.submit()
			}
		}
		const submitWithSubmitter = (submitter) => {
			// If the user clicked a named submit button, preserve its name=value
			if (submitter && submitter.name) {
				if (typeof form.requestSubmit === 'function') {
					form.dataset.boBypassSubmit = '1'
					form.requestSubmit(submitter)
					return
				}

				// Fallback for older browsers: inject a hidden input with the submitter name/value
				const hidden = document.createElement('input')
				hidden.type = 'hidden'
				hidden.name = submitter.name
				hidden.value = submitter.value ?? ''
				form.appendChild(hidden)
				submitNative()
				hidden.remove()
				return
			}

			submitNative()
		}

		const submitter = e?.originalEvent?.submitter || null
		let type = $form.data('type')
		let ctitle = $form.data('confirmation-title')
		let ctext = $form.data('confirmation-text')
		let isCloneForm = $form.hasClass('clone-form'); // Verifica se o formulário é o de clone

		if (type) {
			$('#confirmation-modal').data('type', type)
		}

		if (ctext) {
			if (ctitle) {
				$('#confirmation-modal .modal-title').html(ctitle)
			}
			$('#confirmation-modal .modal-body').html(ctext)

			// Adiciona checkbox dinamicamente se for um formulário de clone
			if (isCloneForm) {
				let duplicatePaymentText = $form.data('duplicate-payment-text'); // Pega o texto da tradução
				let hasPayment = $form.data('has-payment');
				if(hasPayment == 1){
					// default to not duplicating unless user checks
					$(form).find('input[name="duplicatePayment"]').val('0');
					$('#confirmation-modal .modal-body').append(`
						<div class="form-check mt-3">
							<input type="checkbox" class="form-check-input" id="duplicatePaymentCheckbox">
							<label class="form-check-label" for="duplicatePaymentCheckbox">
								${duplicatePaymentText}
							</label>
						</div>
					`);
				}

				// Atualiza o valor da input `duplicatePayment` ao marcar/desmarcar
				$('#confirmation-modal')
					.off('change.backofficeClone', '#duplicatePaymentCheckbox')
					.on('change.backofficeClone', '#duplicatePaymentCheckbox', function() {
						$(form).find('input[name="duplicatePayment"]').val(this.checked ? '1' : '0');
					});
			}

			let modal = bootstrap.Modal.getOrCreateInstance('#confirmation-modal')
			$('#confirmation-modal')
				.off('hidden.bs.modal.backofficeConfirm')
				.one('hidden.bs.modal.backofficeConfirm', function () {
				modal.dispose()
			})
			$('#confirmation-modal #modal-confirm')
				.off('click.backofficeConfirm')
				.one('click.backofficeConfirm', function() {
				modal.hide()
				if (type === 'order') return
				submitWithSubmitter(submitter)
			})

			$('#confirmation-modal .btn-close').html('')
			modal.show()
		} else {
			if (type === 'order') return
			submitWithSubmitter(submitter)
		}
	})

	$(document).on('click', '.chart-export-btn', function(e) {
		/* <div class="dropdown">
			<a class="card-dropdown-actions" type="button" id="dropdownMenu" data-bs-toggle="dropdown" aria-expanded="false">
				<i class="fas fa-ellipsis-h"></i>
			</a>
			<ul class="dropdown-menu" aria-labelledby="dropdownMenu">
				<li>
					<button class="dropdown-item chart-export-btn" data-type="svg" type="button">{{ __('backoffice.dashboard.export-svg') }}</button>
				</li>
				<li>
					<button class="dropdown-item chart-export-btn" data-type="png" type="button">{{ __('backoffice.dashboard.export-png') }}</button>
				</li>
				<li>
					<button class="dropdown-item chart-export-btn" data-type="csv" type="button">{{ __('backoffice.dashboard.export-csv') }}</button>
				</li>
			</ul>
		</div> */

		let type = $(this).data('type')
		if (!type) return;
		let croot = $(this).closest('.chart-card').find('.chart-root')
		if (!croot) return;

		let export_action = false

		switch (type) {
			case "svg":
				export_action = croot.find('.exportSVG')
				if (!export_action) return;
				export_action.trigger('click')
				break;
			case "png":
				export_action = croot.find('.exportPNG')
				if (!export_action) return;
				export_action.trigger('click')
				break;
			case "csv":
				export_action = croot.find('.exportCSV')
				if (!export_action) return;
				export_action.trigger('click')
				break;
		}
	})

	$(document).on('change', '.has-dynamic-input-trigger', function(e) {
		let el = $(this)
		let input = $(`.${ el.attr('name') }-subject`)

		if (Array.isArray(input)) {
			input = input[0]
		}
		
		let target = input.closest('.dynamic-input-parent')
		if (target) {
			function makeParentVisible(target) {
				target.removeClass('d-none').addClass('show')
			}
			function makeParentInvisible(target) {
				target.removeClass('show').addClass('d-none')
			}

			switch (input.data('type')) {
				case 'value':
					if (input.data('value') == el.val())
						makeParentVisible(target)
					else
						makeParentInvisible(target)
					
					break;
			}
		}
	})

	$(document).on('click', 'a[data-toggle=modal][data-target], button[data-toggle=modal][data-target]', event => {
		var target = $(this).data('tab')

		if (target) {
			$(`#v-pills-${ target }-tab`).trigger('click')
		}
	})

    let invalid_inputs = $('.tab-content .tab-pane input.is-invalid')
    if (invalid_inputs.length) {
        let tab = invalid_inputs.first().closest('.tab-pane').attr('id')
        $(`#${ tab }-tab`).trigger('click')

		invalid_inputs.each((_, input) => {
			let i_tab = $(input).closest('.tab-pane').attr('id')
			let tab_elem = $(`#${ i_tab }-tab`)
			
			if (!tab_elem.hasClass('is-invalid')) {
				tab_elem.addClass('is-invalid')
			}
		})
    }

	$(document).on('click', '.copy-to-clipboard-btn', function (e) {
		e.preventDefault();
		const text = $(this).data('clipboard-text');
		const $icon = $(this).find('i');

		copyToClipboard(text)
			.then(() => {
				if ($icon && $icon.length) {
					const originalClasses = $icon.attr('data-original-classes') || $icon.attr('class');
					$icon.attr('data-original-classes', originalClasses);
					$icon.attr('class', 'fa-solid fa-check text-success');

					setTimeout(() => {
						$icon.attr('class', originalClasses);
					}, 2000);
				}
			})
			.catch(() => {
				// optionally show an error message
			});
	});

	$(document).on('show.bs.tab', 'button[data-bs-toggle="tab"]', function (event) {
		const triggerEl = event.target || this
		window.dispatchEvent(new CustomEvent('tab-selected', {
			detail: {
				tab: triggerEl?.getAttribute?.('data-bs-target') || null,
				triggerEl: triggerEl,
			},
		}))
	})
})
